<template>
  <div>
    <div class="mb-8">
      <span class="titulo-pagina">
        {{ tituloFormulario }}
      </span>
      <div>
        <v-chip v-if="form.codigo" class="mr-1" small>
          {{
            $t('modulos.ordem_servico.os_movimentar_situacao.ordem_servico')
          }}: {{ form.codigo }}
        </v-chip>
      </div>
    </div>

    <div>
      <span>
        {{ subtituloFormulario }}
      </span>
    </div>

    <div>
      <div class="container-form">
        <v-form ref="form" class="row mt-2">
          <input-date
            v-model="form.dataPrevisaoEntrega"
            :label="
              $t(
                'modulos.ordem_servico.formulario.previsao_entrega.data_previsao'
              )
            "
            :placeholder="$t('geral.inputs.selecione')"
            :class="apenasVisualizar ? 'col-12 col-md-2' : 'col-12 col-md-3'"
            apenas-datas-futuras
            disabled
          />
          <input-date
            v-model="form.dataNovaPrevisaoEntrega"
            :label="
              $t(
                'modulos.ordem_servico.formulario.previsao_entrega.nova_data_previsao'
              )
            "
            :placeholder="$t('geral.inputs.selecione')"
            class="col-12 col-md-3"
            :disabled="apenasVisualizar"
            :obrigatorio="true"
          />

          <input-text
            v-model="form.observacao"
            :label="
              $t('modulos.ordem_servico.formulario.previsao_entrega.observacao')
            "
            class="col-12 col-md-3"
            :disabled="apenasVisualizar"
          />
        </v-form>
      </div>

      <div v-if="aprovarBoolean" class="mt-4">
        <logs-negociacao :id="id" />
      </div>
    </div>

    <v-divider class="my-5" />
    <div class="d-flex align-center justify-end">
      <botao-padrao
        v-if="apenasVisualizar"
        outlined
        color="secondary"
        class="mr-2"
        @click="voltar"
      >
        <v-icon>$mdiArrowLeft</v-icon>
        {{ $t('geral.botoes.voltar') }}
      </botao-padrao>
      <template v-else>
        <botao-padrao outlined color="secondary" class="mr-2" @click="cancelar">
          <v-icon>$mdiCancel</v-icon>
          {{ $t('geral.botoes.cancelar') }}
        </botao-padrao>
        <botao-padrao @click="confirmacaoSalvar">
          <v-icon>$mdiContentSaveOutline</v-icon>
          {{
            aprovarBoolean
              ? $t('geral.botoes.finalizar')
              : $t('geral.botoes.salvar')
          }}
        </botao-padrao>
      </template>
    </div>
  </div>
</template>

<script>
import { PrevisaoEntregaModel } from '@/common/models/cadastros/PrevisaoEntregaModel.js';
import { OrdemServicoService } from '@/common/services/cadastros';
import helpers from '@/common/utils/helpers';
import ParticipanteService from '@common/services/cadastros/ParticipanteService';
import LogsNegociacao from './components/LogsNegociacao.vue';

export default {
  name: 'OrdemServicoFormulario',
  components: {
    LogsNegociacao,
  },
  props: {
    id: { type: String, default: null },
    aprovar: { type: String, default: 'false' },
  },
  data() {
    return {
      apenasVisualizar: false,
      valido: false,
      form: new PrevisaoEntregaModel({}),
      estaAguardandoAnaliseTecnica: false,
      participanteLogado: {},
    };
  },
  computed: {
    aprovarBoolean() {
      return this.aprovar === 'true';
    },
    tituloFormulario() {
      if (this.id && this.aprovarBoolean) {
        return this.$t(
          'modulos.ordem_servico.titulos.aprovar_previsao_entrega'
        );
      } else if (this.id && !this.aprovarBoolean) {
        return this.$t('modulos.ordem_servico.titulos.editar_previsao_entrega');
      }

      return this.$t(
        'modulos.ordem_servico.titulos.visualizar_previsao_entrega'
      );
    },
    subtituloFormulario() {
      if (this.participanteLogado.flagParticipanteConta) {
        return this.$t(
          'modulos.ordem_servico.formulario.previsao_entrega.subtitulo.ehParticipanteConta'
        );
      }

      return `${this.$t(
        'modulos.ordem_servico.formulario.previsao_entrega.subtitulo.naoEhParticipanteConta'
      )} ${
        this.form && this.form.clienteParticipante
          ? this.form.clienteParticipante.nome
          : ''
      }`;
    },
  },
  mounted() {
    this.$store.dispatch('Layout/alterarTituloPagina', this.tituloFormulario);

    if (this.$route.name.includes('visualizar')) this.apenasVisualizar = true;
    if (this.id) {
      helpers.redirecionarSemPermissao(this, 'OrdemServico', 'Editar');
      this.buscar(this.id);
    }
    this.buscarParticipanteLogado();
    helpers.redirecionarSemPermissao(this, 'OrdemServico', 'Inserir');
  },
  methods: {
    buscar() {
      this.$store.dispatch('Layout/iniciarCarregamento');
      OrdemServicoService.buscar(this.id)
        .then((res) => {
          this.form = new PrevisaoEntregaModel(res.data);
          this.verificarSituacaoOrcamento(this.form);
          if (this.aprovarBoolean) {
            this.buscarPrevisaoEntrega();
          }
          this.valido = true;
          this.$store.dispatch('Layout/terminarCarregamento');
        })
        .catch(() => {
          this.toastErro(this.$t('modulos.ordem_servico.erros.id_invalido'));
        });
    },
    buscarPrevisaoEntrega() {
      OrdemServicoService.buscarOrdemServicoPrevisaoEntrega(this.id)
        .then((res) => {
          this.form.dataNovaPrevisaoEntrega = res.data.dataPrevisaoEntrega;
        })
        .catch(() => {
          this.toastErro(this.$t('modulos.ordem_servico.erros.id_invalido'));
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    async buscarParticipanteLogado() {
      await ParticipanteService.buscar(
        this.$store.getters['Autenticacao/participanteSelecionado']
      )
        .then((res) => {
          this.participanteLogado = res.data;
        })
        .catch(() => {
          this.toastErro(this.$t('modulos.ordem_servico.erros.id_invalido'));
        });
    },
    verificarSituacaoOrcamento(form) {
      this.estaAguardandoAnaliseTecnica = form.ordensServicosInstrumentos.every(
        (item) => item.situacao === 'AguardandoAnaliseTecnica'
      );
    },
    confirmacaoSalvar() {
      if (!this.validarFormPrevisao()) return;
      if (this.id) {
        this.confirmarSalvar().then(() => {
          this.salvar();
        });
      } else this.salvar();
    },
    validarFormPrevisao() {
      return this.$refs.form.validate();
    },
    alterarPrevisaoEntrega: async function (request) {
      this.$store.dispatch('Layout/iniciarCarregamento');
      OrdemServicoService.alterarPrevisaoEntrega(request)
        .then(async () => {
          this.toastSucesso(
            `Previsão de entrega da Ordem de serviço ${this.form.codigo} alterada com sucesso!`
          );
          this.$router.push({
            name: this.$route.query?.retorno || 'ordem-servico',
          });
        })
        .catch((err) => {
          this.toastErro(this.$t(`geral.erros.${err.response.data.errors[0]}`));
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    aprovarPrevisaoEntrega: async function (request) {
      this.$store.dispatch('Layout/iniciarCarregamento');
      OrdemServicoService.aprovarPrevisaoEntrega(request)
        .then(async () => {
          this.toastSucesso(
            `Nova Previsão de entrega da Ordem de serviço ${this.form.codigo} aprovada com sucesso!`
          );
          this.$router.push({
            name: this.$route.query?.retorno || 'ordem-servico',
          });
        })
        .catch((err) => {
          this.toastErro(this.$t(`geral.erros.${err.response.data.errors[0]}`));
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    salvar: async function () {
      const request = {
        ordemServicoId: this.form.id,
        dataPrevisao: this.form.dataNovaPrevisaoEntrega,
        observacao: this.form.observacao,
      };

      if (this.aprovarBoolean) {
        await this.aprovarPrevisaoEntrega(request);
      } else {
        await this.alterarPrevisaoEntrega(request);
      }
    },
    cancelar() {
      this.confirmarCancelar().then(() => {
        this.$router.push({
          name: this.$route.query?.retorno || 'ordem-servico',
        });
      });
    },
    validarFormulario(validar) {
      this.valido = validar;
    },
    voltar: function () {
      this.$router.push({
        name: this.$route.query?.retorno || 'ordem-servico',
      });
    },
  },
};
</script>

<style scoped>
.container-form {
  margin-bottom: 50px !important;
}
</style>
